const FEATURES = [
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '支持1080P及4K超清画质播放，每一帧都细腻清晰，带给您影院级的在线看片视觉体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '采用全球CDN加速与智能缓冲技术，视频秒开不等待，91影视高清免费不缓冲的极致流畅。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量资源',
    desc: '收录超过三万部电影、电视剧、动漫、综艺，涵盖国内外热门题材，91精品影视免费观看想看就看。',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步',
    desc: '全面适配桌面端、平板和手机端。无需下载安装，打开浏览器即可享受91影视在线看片。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全免费',
    desc: '本站所有资源完全免费，无隐藏收费，无恶意弹窗。91影视看片免费，安全可靠的观影环境。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50">平台优势</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-xl mx-auto">
            五大核心优势，打造极致的免费在线看片体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {FEATURES.map((f) => (
            <div
              key={f.title}
              className="group p-5 md:p-6 rounded-xl bg-background-100 border border-background-300/30 hover:border-primary-500/30 transition-all duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-400 group-hover:bg-primary-500/20 transition-colors mb-4">
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-100 mb-2">{f.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}